import { TrendingUp, TrendingDown } from "lucide-react";
import { BrutalCard } from "@/components/ui/BrutalCard";

interface KPICardProps {
  title: string;
  value: string | number;
  change?: number;
  trend?: "up" | "down";
  inverse?: boolean;
}

export default function KPICard({ title, value, change, trend, inverse = false }: KPICardProps) {
  const isPositive = inverse ? trend === "down" : trend === "up";

  return (
    <BrutalCard className="p-6">
      <div className="text-sm text-muted-foreground mb-2">{title}</div>
      <div className="text-3xl font-bold mb-2">{value}</div>
      {change !== undefined && trend && (
        <div className={`flex items-center gap-1 text-sm ${isPositive ? "text-success" : "text-destructive"}`}>
          {trend === "up" ? (
            <TrendingUp className="w-4 h-4" />
          ) : (
            <TrendingDown className="w-4 h-4" />
          )}
          <span>{Math.abs(change)}%</span>
        </div>
      )}
    </BrutalCard>
  );
}
